const mutations = {
  setFreelancerCategories(state, payload) {
    state.freelancerCategories = payload
  },
  setSourcingRequestToken(state, payload) {
    state.sourcingRequestToken = payload
  },
  setCurrentTab(state, payload) {
    state.currentTab = payload
  },
  setUserData(state, payload) {
    state.userData = { ...state.userData, ...payload }
  },
  setSummaryRecords(state, payload) {
    console.log('set record',payload)
    state.orderSummaryRecord = payload
  }
}

export default mutations
